import { createElement } from 'react';
import { AuthContext, useAuthProvider } from '../hooks/useAuth';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuthProvider();
  return createElement(AuthContext.Provider, { value: auth }, children);
}
